import React, { useEffect, useState } from 'react';
import { Bubble, Table, TableColumn } from 'tea-component';
import type { ISourceTableProps } from '../../types';
import './index.scss';

const { selectable, scrollable } = Table.addons;

export default function SourceTable(props: ISourceTableProps) {
  const {
    entityRenderer,
    hideHeader,
    entityKey,
    title = '',
    records,
    value,
    handleLoadMore,
    isMoreLoading = false,
    hasShortCut = false,
    isShortCutPage = false,
    isDisabled,
    disabledMsg,
    onChange,
    headerHeight = 0,
    showEntity,
  } = props;

  const [heightValue, setHeightValue] = useState(429);

  // 动态更新 heightValue
  useEffect(() => {
    if (isShortCutPage && isMoreLoading) {
      setHeightValue(430-40-headerHeight);
    } else if (isMoreLoading) {
      setHeightValue(389);
    } else if (isShortCutPage) {
      setHeightValue(430-headerHeight);
    } else {
      setHeightValue(429);
    }
  }, [isMoreLoading, isShortCutPage,headerHeight]);

  const addons = [
    scrollable({
      virtualizedOptions: {
        height: heightValue,
        itemHeight: 58,
        onScrollBottom: () => {
          handleLoadMore();
        },
      },
      maxHeight: heightValue,
    }),
    selectable({
      all: false,
      rowSelect: true,
      value,
      onChange: (rowkey, e) => {
        onChange?.(rowkey, e);
      },
      rowSelectable: (rowkey) =>
        // 勾选数量达到上限后 禁用状态，并且 当前的entity没有被勾选，就禁用，非则 可以勾选（因为在勾选达到上限后，要允许取消勾选）
        !isDisabled || value?.includes(rowkey),
      render: (cvm) => {
        const isChecked = value?.includes(cvm?.props?.name);
        return (
          <Bubble
            arrowPointAtCenter
            dark
            style={{ maxWidth: 346 }}
            content={isDisabled && !isChecked ? disabledMsg : ''}
          >
            {cvm}
          </Bubble>
        );
      },
    }),
  ];

  const columns: TableColumn<any>[] = [
    {
      key: 'data',
      header: title,
      render: (cvm) => {
        if (typeof entityRenderer !== 'function') return null;
        return entityRenderer({ cvm }, '', hasShortCut,showEntity);
      },
    },
  ];

  return (
    <Table
      className="dbi-source-table"
      hideHeader={hideHeader}
      recordKey={entityKey}
      records={records}
      columns={columns}
      addons={addons}
    />
  );
}
